import { TripDetail } from '@/services/trips/trip';

export function countTripNights(trip: TripDetail): number {
  return trip.cities.reduce((acc, city) => acc + city.nights, 0);
}
